// extracted by mini-css-extract-plugin
export default {"container":"Login_container__Bf6S8","content":"Login_content__N1PyJ","form":"Login_form__VRlU5","submitButton":"Login_submitButton__z5Suz"};